export default {
  // TeacherConv.vue
  teacherConv: {
    betaChip: 'BETA',
    teacherTitle: 'Votre prof Tokatab',
    plugPianoInfo: 'Pour brancher votre piano, il faut identifier quel port est présent sur le piano. Il y a globalement 2 types de ports : les ports midi et les ports USB. Cliquez sur le bouton ci-dessous pour accéder à un questionnaire guidé qui vous aidera à identifier la meilleure solution, en fonction de votre piano.',
    plugPianoButton: 'Comment brancher mon piano ?',
    skillRecommendationTitle: 'Voici les compétences que je vous recommande de travailler :',
    skillCategoriesTitle: 'Choisissez une catégorie de compétences à explorer :',
    skillsCount: '{count} compétence{plural}',
    goToPlayerButton: 'Aller dans le player',
    showParameterButton: 'Afficher comment changer le paramètre',
    contactTeamButton: 'Contacter l\'équipe de Tokatab',
    waitingLong: 'Le prof tokatab met parfois du temps à réfléchir, un peu de patience...',
    waitingTooLong: 'Le prof Tokatab a peut être eu un problème. Vous pouvez annuler et réessayer.',
    cancelButton: 'Annuler',
    messagesRecordedNotice: 'Les messages peuvent être enregistrés afin d\'améliorer le prof.',
    messagesRemaining: 'Messages restants : {current}/{total} cette semaine',
    inputPlaceholderQuotaExceeded: 'Quota de messages épuisé cette semaine',
    inputPlaceholderDisabled: 'Le prof est en train d\'écrire...',
    inputPlaceholder: 'Parler avec le prof Tokatab',
    quotaExceededMessage: 'Vous avez épuisé votre quota de messages avec le prof cette semaine. Abonnez-vous à Tokatab premium pour des messages illimités !',
    subscribeButton: 'S\'abonner',
    betaWarningTitle: 'Le prof Tokatab est en version expérimentale, n\'hésitez pas à nous écrire pour nous dire ce que vous en pensez !',
    betaWarningButton: 'Commencer la discussion',
    conversationStarters: {
      dontKnowWhatToPlay: 'Je ne sais pas quel morceau jouer.',
      cantPlayBothHands: 'Je n\'arrive pas à jouer les deux mains ensemble.',
      playFrequency: 'À quelle fréquence faut-il jouer ?',
      plugPiano: 'Comment brancher mon piano ?',
      positioning: 'Comment bien se positionner pour jouer ?',
      levelTest: 'Je veux passer le test de niveau.',
      cantFindLessons: 'Je ne trouve pas les leçons.',
      cantHearSound: 'Je n\'entends pas bien le son.',
      lowerTempo: 'Comment baisser le tempo ?',
      showNoteNames: 'Comment afficher le nom des notes ?',
      whatSkillsToWork: 'Quelles compétences dois-je travailler ?',
      helpChooseSkill: 'Aidez-moi à choisir une compétence à développer.'
    }
  },

  // TeacherChatBubble.vue
  teacherChatBubble: {
    retryButton: 'Recommencer',
    increaseTempo: 'Augmenter le tempo',
    trySlower: 'Essayer plus lentement',
    activateListeningQuestion: 'Vous n\'avez pas activé le mode écoute, souhaitez-vous l\'activer ?',
    activateButton: 'Activer',
    dontAskAgainButton: 'Ne plus me demander',
    noThanksButton: 'Non merci'
  },

  // TeacherKeywordExplainer.vue
  teacherKeywordExplainer: {
    explainTooltip: 'Expliquer ce terme',
    explainPrompt: 'Explique moi ce terme : {keyword}'
  },

  // TeacherChatbot.vue
  teacherChatbot: {
    welcomeMessage: 'Salut ! Je suis le prof de piano Tokatab, comment puis-je vous aider ?',
    premiumNotification: 'Vous avez épuisé votre quota de messages avec le prof cette semaine. Abonnez-vous à Tokatab premium pour des messages illimités !',
    subscribeButton: 'S\'abonner',
    pageCaptureError: 'Erreur lors de la capture du contenu de la page:'
  },

  // TeacherService.ts
  teacherService: {
    redirecting: 'Je vous redirige vers la page demandée.',
    paused: 'J\'ai mis le morceau en pause.',
    restarted: 'J\'ai redémarré le morceau.',
    started: 'J\'ai démarré le morceau.',
    validated: 'Bravo, j\'ai validé le contenu en cours !',
    tempoSlowed: 'J\'ai ralenti le tempo du morceau.',
    tempoIncreased: 'J\'ai accéléré le tempo du morceau.',
    tempoModified: 'J\'ai modifié le tempo du morceau.',
    volumeIncreased: 'J\'ai augmenté le volume demandé.',
    volumeDecreased: 'J\'ai diminué le volume demandé.',
    volumeActivated: 'J\'ai activé le volume demandé.',
    volumeDeactivated: 'J\'ai désactivé le volume demandé.'
  },

  // TeacherSpeechRecognition.vue
  teacherSpeechRecognition: {
    notAvailable: 'Le mode écoute n\'est pas disponible dans ce navigateur. Veuillez utiliser un autre navigateur (Google Chrome, Safari, Edge, etc.)',
    listeningActivated: 'Mode écoute activé, parlez pour m\'envoyer un message.',
    listeningDeactivated: 'J\'ai désactivé le mode écoute.'
  }
}
